// Types
import type { NotificationSubscriptionProps } from '@/utils/hooks/context/toast/types';

// Component
import Notification from '@/components/base/Notification';

// Routes
import { SUBSCRIPTION_INVOICES } from '@/routes/privateRoutes';

const OptionsCancellationReminder = ({ notification }: NotificationSubscriptionProps) => {
    return (
        <Notification
            dataNotification={notification}
            goToUrl={`${SUBSCRIPTION_INVOICES}?step=edit_addons`}
            contentHidden={notification?.options?.hideContent ?? false}
            wide={notification?.options?.wide ?? true}>
            <Notification.Icon icon="paid-data" />
            <Notification.Content>
                <Notification.Title i18nKey="commons:notifications.options_cancellation_reminder.title" />
                <Notification.Description i18nKey="commons:notifications.options_cancellation_reminder.description" />
            </Notification.Content>
        </Notification>
    );
};

export default OptionsCancellationReminder;
